import './styles.css';
import { initChat } from './chat';

const BOOKING_URL = 'https://calendar.app.google/t9LfEV1Q2VdYCNoSA';

document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('app');
  if (!root) return;
  initChat(root, { bookingUrl: BOOKING_URL });
});
